import axios from 'axios';
import sesionService from '@/services/SesionService';

export default {
	async getAllTeamsSimple() {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get('/team/all-simple', HEADER);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async getAllTeams() {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get('/team/all', HEADER);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async getTeam(id) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get('/team/' + id, HEADER);
				return res.data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async postTeam(
		name,
		users,
		children,
		categories,
		requiredDocuments,
		featuredDocuments,
		requiredDatas,
		featuredDatas
	) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '')
			return axios
				.post(
					'/team',
					{
						name,
						users,
						children,
						categories,
						requiredDocuments,
						featuredDocuments,
						requiredDatas,
						featuredDatas
					},
					HEADER
				)
				.then((res) => res.data);
	},

	async putTeam(
		id,
		name,
		users,
		children,
		categories,
		requiredDocuments,
		featuredDocuments,
		requiredDatas,
		featuredDatas
	) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '')
			return axios
				.put(
					'/team/' + id,
					{
						name,
						users,
						children,
						categories,
						requiredDocuments,
						featuredDocuments,
						requiredDatas,
						featuredDatas
					},
					HEADER
				)
				.then((res) => res.data);
	},

	async deleteTeam(id) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') return axios.delete('/team/' + id, HEADER).then((res) => res.data);
	}
};
